import { createLanguagePreference } from './language';

/** The page's one language preference (T-0472): the choice, its cache and the browser's languages. */
export const languagePreference = createLanguagePreference();
